import { useState, Fragment } from 'react';
import { Keyboard, ChevronDown, ChevronUp } from 'lucide-react';

interface Shortcut {
  keys: string[];
  description: string;
  category: string;
}

const shortcuts: Shortcut[] = [
  { keys: ['Ctrl/⌘', 'K'], description: 'Open command palette', category: 'General' },
  { keys: ['/'], description: 'Open command palette', category: 'Navigation' },
  { keys: ['Esc'], description: 'Close dialogs', category: 'General' },
  { keys: ['Alt', '1-5'], description: 'Switch navigation domain', category: 'Navigation' },
  { keys: ['⌘', '⇧', 'F'], description: 'Toggle favorites', category: 'Navigation' },
  { keys: ['⌘', 'B'], description: 'Toggle sidebar', category: 'Navigation' },
  { keys: ['Right Click'], description: 'Context menu (on nav items)', category: 'Navigation' },
  { keys: ['⌘', 'E'], description: 'Expand all sections', category: 'Navigation' },
  { keys: ['⌘', 'W'], description: 'Collapse all sections', category: 'Navigation' },
];

export function NavigationShortcuts() {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isExpanded) {
    return (
      <button
        onClick={() => setIsExpanded(true)}
        className="w-full flex items-center justify-between px-3 py-2 text-xs text-gray-500 hover:text-gray-700 hover:bg-gray-50 rounded-lg transition"
      >
        <div className="flex items-center space-x-2">
          <Keyboard className="w-3.5 h-3.5" />
          <span>Keyboard Shortcuts</span>
        </div>
        <ChevronDown className="w-3.5 h-3.5" />
      </button>
    );
  }

  const categories = Array.from(new Set(shortcuts.map((s) => s.category)));

  return (
    <div className="border border-gray-200 rounded-lg bg-gray-50 overflow-hidden">
      <div className="flex items-center justify-between px-3 py-2 bg-white border-b border-gray-200">
        <div className="flex items-center space-x-2">
          <Keyboard className="w-3.5 h-3.5 text-gray-500" />
          <span className="text-xs font-semibold text-gray-700">Keyboard Shortcuts</span>
        </div>
        <button
          onClick={() => setIsExpanded(false)}
          className="p-1 text-gray-400 hover:text-gray-600 rounded transition"
        >
          <ChevronUp className="w-3.5 h-3.5" />
        </button>
      </div>

      <div className="p-3 space-y-3 max-h-64 overflow-y-auto">
        {categories.map((category) => (
          <div key={category}>
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
              {category}
            </div>
            <div className="space-y-1.5">
              {shortcuts
                .filter((s) => s.category === category)
                .map((shortcut, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between text-xs"
                  >
                    <span className="text-gray-600">{shortcut.description}</span>
                    <div className="flex items-center space-x-1">
                      {shortcut.keys.map((key, keyIndex) => (
                        <Fragment key={keyIndex}>
                          <kbd className="px-1.5 py-0.5 font-mono text-xs font-semibold text-gray-700 bg-white border border-gray-300 rounded shadow-sm">
                            {key}
                          </kbd>
                          {keyIndex < shortcut.keys.length - 1 && (
                            <span className="text-gray-400">+</span>
                          )}
                        </Fragment>
                      ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}




























